import React from 'react';
import BaseComponent from 'components/BaseComponent';
import Icon from 'components/Icon';
import { Img } from 'components/Material';
import { Row, Col, Modal } from 'antd';
import { getShowPreviewObj } from '@/routes/Material/Util/components/materialUtil';
import { LargePictureComponent } from '@/routes/Material/Util/index';
import 'components/Slider/index.less';
import 'components/Modal/modal.less';
import {
  calculateWH,
} from '@/utils/common';

/** 在线预览图片组件 */
export class PicturePreviewComponent extends BaseComponent {

    state = {
        currentIndex: 0,
        largeVisible: false,
        checkObj: this.props.checkObj,
    }

    componentWillReceiveProps(nextProps) {
        let { visible, checkObj } = nextProps;
        if (visible) {
            this.setState({
                currentIndex: 0,
                checkObj
            });
        }
    }

    /** 切换显示图片索引 */
    onChangeIndex = (e, index) => {
        if(e) {
            e.preventDefault;
            e.stopPropagation;
        }
        this.setState({
            currentIndex: index,
        });
    }

    /** 放大图片  */
    onShowLargePicture = (e) => {
        this.setState({
            largeVisible: true,
        });
    }

    /** 查看原图 关闭窗口 */
    hideLargePictureHandler = () => {
        this.setState({
            largeVisible: false,
        });
    }

    /** 
     * 查看下一张或者前一张
     * 0:前一张 1: 下一张
     */
    onNextPreMaterial = (nextPre) => {
        let { previewRows } = this.props;
        let checkObj = this.state.checkObj;
        let showPreviewObj = getShowPreviewObj(nextPre, previewRows, checkObj);
        if (!showPreviewObj || !showPreviewObj.id) {
            return;
        }
        this.setState({
            checkObj: showPreviewObj,
            currentIndex: 0,
        });
    }

    render() {
        const { title, visible, type, previewRows, hidePreviewHandler } = this.props;
        let { currentIndex, checkObj } = this.state;
        if (!checkObj || !checkObj.id) {
            return null;
        }
        let isNextPre = true;
        if (!previewRows || previewRows.length <= 1) {
            isNextPre = false;
        }
        let arrSrc = [];
        let arrSize = [];
        let officeShowStyle = {};
        let officeShowDiv = null;
        let pageDiv = null;

        if (type === '15' || type === '16' || type === '17' || type === '35') {//Office文件
            let previewList = checkObj.previewList;
            if (!previewList || previewList.length <= 0) {
                return null;
            }
            if (previewList.length > 200) {
                previewList.splice(200, previewList.length);
            }
            for (let item of previewList) {
                arrSrc.push(item.path);

                let sizeObj = calculateWH(item.sense.toLowerCase().split('x')[0].trim(), item.sense.toLowerCase().split('x')[1].trim(),  620, 500);
                arrSize.push({"width": sizeObj.width, "height": sizeObj.height });
            }
            let officeRight = arrSrc.map((item, index) => {
                let checkStyle = "";
                if(index === currentIndex) {
                    checkStyle = "office-preview-check";
                }
                return (
                    <Col key={index}>
                        <div className={`office-preview-div ${checkStyle}`}
                            onClick={(e) => {
                                this.onChangeIndex(e, index)
                            }}>
                            <Img src={item} className="office-preview-img" />
                        </div>
                    </Col>
                )
            });
            officeShowDiv = (
                <div className="office-preview">
                    <div className="office-preview-body">
                        <Row>{officeRight}</Row>
                    </div>
                </div>
            );
            pageDiv = (
                <div className="original-page-tip">{currentIndex + 1}/{previewList.length}</div>
            );
            officeShowStyle = {
                width: '648px',
                float: 'left',
            };
        } else {//图片，视频等文件
            let path = checkObj.path || checkObj.sourcepath;
            arrSrc = [path];

            let sense = checkObj.sense || checkObj.filesense;

            if (!sense) {
                sense = "100x100";
            }

            let sizeObj = calculateWH(sense.toLowerCase().split('x')[0].trim(), sense.toLowerCase().split('x')[1].trim(),  900, 500);
            arrSize = [{"width": sizeObj.width, "height": sizeObj.height }];
        }
        
        if (arrSrc.length <= 0) {
            return null;
        }

        /** 放大参数 */
        const largeProps =  {
            visible: this.state.largeVisible,
            src: arrSrc[currentIndex],
            hideLargePictureHandler: this.hideLargePictureHandler
        }
        let newTitle = title;
        if (checkObj.name && checkObj.suffix) {
            newTitle = title + " - " + checkObj.name + "." + checkObj.suffix;
        }
        return (
            <Modal
                title={newTitle}
                visible={visible}
                width={930}
                maskClosable={false}
                onCancel={hidePreviewHandler}
                footer={null}
                className="original-preview-model show-modal-head"
            >
                {isNextPre ? (
                    <div className="original-left">
                        <Icon className="left-arrow-o" onClick={(e) => { this.onNextPreMaterial(0) }} />
                    </div>
                ) : null }
                {isNextPre ? (
                    <div className="original-right">
                        <Icon className="right-arrow-o" onClick={(e) => { this.onNextPreMaterial(1) }} />
                    </div>
                ) : null }
                <div className="original-preview" style={officeShowStyle}>
                    <div className="original-preview-body">
                        <Img src={arrSrc[currentIndex]} style={arrSize[currentIndex]} className="original-preview-img" />
                    </div>
                    <div className="original-foot">
                        {pageDiv}
                        <Icon className="large original-large-icon" onClick={(e) => { this.onShowLargePicture() }} />
                    </div>
                </div>
                {officeShowDiv}
                <LargePictureComponent {...largeProps} />
            </Modal>
        )
    }

}




// WEBPACK FOOTER //
// ./src/routes/Material/Util/components/picturePreviewComponent.js